import { useChatStateStore, useMessagesStore, useToastStore } from '../../zustand/store';
import MarkDownConverter from '../Markdown';
import { LoadingBubbleModal } from '../ChatBubble';
import { useEffect, useRef } from 'react';
import Toast from '../Toast';

export const StreamView = () => {
    const { streamMessage, messages, clearMessages } = useMessagesStore();
    const { isStreaming, isChatbotPending } = useChatStateStore();
    const streamContainerRef = useRef(null);
    const { setToastMessage, setIsToastVisible } = useToastStore();

    useEffect(() => {
        if (isStreaming && messages.length > 0) {
            console.log('clearMessages');
            clearMessages();
        }
    }, [isStreaming]);

    // 스트리밍 중 자동 스크롤 기능
    useEffect(() => {
        if (isStreaming && streamContainerRef.current) {
            const container = streamContainerRef.current;

            requestAnimationFrame(() => {
                container.scrollTop = container.scrollHeight;
            });
        }
    }, [streamMessage, isStreaming]);

    // 메시지가 추가될 때 자동 스크롤
    useEffect(() => {
        if (messages.length > 0 && streamContainerRef.current) {
            const container = streamContainerRef.current;

            requestAnimationFrame(() => {
                container.scrollTop = container.scrollHeight;
            });
        }
    }, [messages]);
    
    return (
        <div 
            ref={streamContainerRef} 
            style={{ width: '100%', flex: 1, position: 'relative', padding: '8px 0', height: '100%', overflow: 'scroll', overscrollBehavior: 'contain', marginBottom: '8px' }}
        >
            <div style={{ width: '100%', height: '100%' }}>
                {
                    isChatbotPending &&
                    <div>
                        <LoadingBubbleModal />
                    </div>
                }
                {
                    isStreaming &&
                    <div
                        style={{ width: '100%', padding: '0px 16px', marginBottom: '10px' }} 
                    >
                        <MarkDownConverter text={streamMessage}/>
                    </div>
                }
                {
                    messages.length > 0 && messages[messages.length - 1]?.isChatbot &&
                    <div
                        style={{ width: '100%', padding: '0px 16px', marginBottom: '10px' }} 
                    >
                        <MarkDownConverter text={messages[messages.length - 1]?.message} />
                    </div>
                }
            </div>
            <Toast bottom='200px'/>
        </div>
    )
}